import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface BalanceHistoryItem {
  amount: number;
  type: string;
  user: string;
  ipAddress: string | null;
  comments: string | null;
  addedBy: string | null;
  createdAt: string;
  parentBalanceHistory: {
    id: string;
    type: string;
    reason: string;
    change: number;
    createdAt: string;
  } | null;
}

export interface BalanceHistoryResponse {
  history: BalanceHistoryItem[];
  total: number;
}

export interface GetBalanceHistoryInput {
  userId?: number; // Made optional to support fetching all users' history
  includeTypes?: string[];
  limit?: number;
  offset?: number;
  startDate?: string; // ISO date string, optional
  endDate?: string; // ISO date string, optional
  environmentID?: number;
}

const GET_BALANCE_HISTORY = gql`
  query GetBalanceHistory($input: GetBalanceHistoryInput!, $all: Boolean) {
    getBalanceHistory(input: $input, all: $all) {
      history {
        amount
        type
        user
        ipAddress
        comments
        addedBy
        createdAt
        parentBalanceHistory {
        id
        type
        reason
        change
        createdAt
      }
      }
      total
      
      
    }
  }
`;

export const getBalanceHistory = async (
  input: GetBalanceHistoryInput,
  all?: boolean,
): Promise<BalanceHistoryResponse> => {
  try {
    console.log('input', input);
    const { data } = await apolloClient.query<{
      getBalanceHistory: BalanceHistoryResponse;
    }>({
      query: GET_BALANCE_HISTORY,
      variables: { input, ...(all !== undefined ? { all } : {}) },
      fetchPolicy: 'network-only',
    });
    
    return data.getBalanceHistory;
  } catch (error) {
    console.error('Error fetching balance history:', error);
    throw error;
  }
};

// Convenience function for getting balance history with default parameters
export const getBalanceHistoryByUserId = async (
  userId: number,
  includeTypes?: string[],
  limit: number = 10,
  offset: number = 0,
  startDate?: string,
  endDate?: string,
  all?: boolean,
  
): Promise<BalanceHistoryResponse> => {
  console.log({
      userId,
      includeTypes,
      limit,
      offset,
      startDate,
      endDate,
    },'aaaaaaaaaa');
  
  return getBalanceHistory(
    {
      userId,
      includeTypes,
      limit,
      offset,
      startDate,
      endDate,
    },
    all,
  );
};
